import { ColumnFiltersState } from '@tanstack/react-table';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export function useTableFilter<T>(setFilters: Dispatch<SetStateAction<T>>) {
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  useEffect(() => {
    setFilters((prev) => {
      const filter = columnFilters.length === 0 ? ({} as T) : { ...prev };
      columnFilters.forEach(({ id, value }) => {
        filter[id as keyof T] = value as any;
      });

      return filter;
    });
  }, [columnFilters, setFilters]);

  return { columnFilters, setColumnFilters };
}
